import React from 'react';
import { Card, Button, Typography, Spin, Alert } from 'antd';
import useCertificate from '../hooks/useCertificate';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';

const { Title, Paragraph, Text } = Typography;

type CertificateCardProps = {
  t: (key: string) => string;
};

const CertificateCard: React.FC<CertificateCardProps> = ({ t }) => {
  const { certificate, loading, generateCertificate, error } = useCertificate();
  const certificateEnabled = useSelector((state: RootState) => state.instance.certificateEnabled);

  return (
    <Card className="certificate-card">
      <Title level={4} style={{ marginBottom: 24 }}>{t('document.certificateTitle')}</Title>
      {/* Certificate logic section */}
      {!certificateEnabled ? (
        <Alert message={t('document.certificateDisabled')} type="warning" showIcon style={{ marginBottom: 16 }} />
      ) : loading ? (
        <div style={{ textAlign: 'center', minHeight: 120, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Spin size="large" />
        </div>
      ) : error ? (
        <>
          <Alert message={error} type="error" showIcon style={{ marginBottom: 16 }} />
          <Button type="primary" onClick={generateCertificate}>{t('document.generateCertificate')}</Button>
        </>
      ) : !certificate ? (
        <>
          <Text type="warning">{t('document.noCertificate')}</Text>
          <div style={{ marginTop: 20 }}>
            <Button type="primary" className='btn-primary' onClick={generateCertificate}>{t('document.generateCertificate')}</Button>
          </div>
        </>
      ) : (
        <>
          <Paragraph>{t('document.certificateReady')}</Paragraph>
          <Button type="primary" className='btn-primary' href={certificate.fileUrl} target="_blank" download>{t('document.download')}</Button>
        </>
      )}
    </Card>
  );
};

export default CertificateCard;
